import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { MyFleetVessels } from '../../../../models/my-fleet.model';

interface MyFleetVesselErrorTableProps {
  vessels: MyFleetVessels | null;
}

export default function MyFleetVesselConfirmationTable({
  vessels,
}: MyFleetVesselErrorTableProps) {
  return (
    <Table size="small" stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell sx={{ backgroundColor: 'primary.main' }}>IMO</TableCell>
          <TableCell sx={{ backgroundColor: 'primary.main' }}>Name</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {(vessels || []).map((vessel) => (
          <TableRow key={vessel.imo}>
            <TableCell>{vessel.imo}</TableCell>
            <TableCell>{vessel.name || 'Unknown Vessel'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
